import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import store from '@/store'
import gdroidService from '@/service/gdroid.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const firebaseConfig = {
  apiKey: "AIzaSyCYdztTgy4otlOiOs03m9J5BFoBUArqV0U",
  authDomain: "opentext-d4d09.firebaseapp.com",
  databaseURL: "https://opentext-d4d09.firebaseio.com",
  projectId: "opentext-d4d09",
  storageBucket: "opentext-d4d09.appspot.com",
  messagingSenderId: "144479104452",
  appId: "1:144479104452:web:0f360def0245efee530891",
  measurementId: "G-T1SQRJ6K6R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const messaging = getMessaging()
onMessage(messaging, (payload) => {
  console.log('Message received. ', payload)
  // ...
})

// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
getToken(messaging, { vapidKey: 'BDyr9KBjJF-_DSyALzKGN5Rq-40vfQqJ9bH73u_yr-d711zMljEvCVW5xQMLlrFzTVs38nUQixCbWBmfIr394mQ' }).then((clientNotificationToken) => {
  if (clientNotificationToken) {
    localStorage.setItem(store.state.clientNotificationTokenLocalStorageKeyName, clientNotificationToken)
    store.state.clientNotificationToken = clientNotificationToken
    console.log('token: ', localStorage.getItem(store.state.clientNotificationTokenLocalStorageKeyName))
    
    // Send the token to your server and update the UI if necessary
    const oAuthToken = localStorage.getItem(store.state.oAuthTokenLocalStorageKeyName) as string
    gdroidService.notificationToken(oAuthToken)  
    // ...
  } else {
    // Show permission request UI
    console.log('No registration token available. Request permission to generate one.')
    // ...
  }
}).catch((err) => {
  console.error(err)
  // ...
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", null, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" | "),
      _createVNode(_component_router_link, { to: "/about" }, {
        default: _withCtx(() => [
          _createTextVNode("About")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_router_view)
  ], 64))
}
}

})